export class InputType {
    public static readonly Currency = 'currency';
    public static readonly Number = 'number';
    public static readonly Text = 'text';
}
